// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  VERSION: '1.0-draft',
  production: false,
  tenantField: '',
  tenant: '',
  companyInfo: {
    slider1: '../assets/images/slider1.png',
    slider2: '../assets/images/slider1.png',
    logoUrl: '',
  },
  microService: {
    jpa: 'jpa',
  },
  SERVER_API_URL: 'https://demo3.nambakada.com/',
  FINANCIAL_YEAR: '2025-26',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
